import throttle from 'lodash.throttle'
import debounce from 'lodash.debounce'

const THROTTLE_DELAY = 200;
const DEBOUNCE_DELAY = 1000;

var windowStatePlugin = {
  install: function(Vue) {
    // ウィンドウの状態
    var state = {
      scrollX: 0,
      scrollY: 0,
      width: 0,
      height: 0,
      viewport: '',
      update: ''
    }
    // スクロール数値を取得
    var onScroll = function() {
      state.scrollX = window.pageXOffset
      state.scrollY = window.pageYOffset
    }
    document.addEventListener('scroll', throttle(onScroll, THROTTLE_DELAY))

    // ウィンドウのサイズを取得
    var onResize = function() {
      state.width = document.documentElement.clientWidth
      state.height = document.documentElement.clientHeight

      var nowViewport = state.viewport;
      state.viewport = state.width >= 1024 ? 'desktop' : 'mobile';
      state.update = nowViewport !== state.viewport;

      // var timer = false;
      // if(timer !== false) clearTimeout(timer);

      // state.width = document.documentElement.clientWidth
      // state.height = document.documentElement.clientHeight

      // // ウィンドウサイズを変更し終えた段階のチェック
      // timer = setTimeout(function() {
      //   var nowViewport = state.viewport;
      //   state.viewport = state.width >= 1024 ? 'desktop' : state.width >= 768 ? 'tablet' : 'mobile';
      //   state.update = nowViewport !== state.viewport;
      // }, 200);
    }
    window.addEventListener('resize', debounce(onResize, DEBOUNCE_DELAY))
    // 初期値を更新
    window.addEventListener('load', function() {
      onScroll()
      onResize()
    })
    // プロパティ $window を定義
    Vue.util.defineReactive(Vue.prototype, '$window', state)
  }
}
export default windowStatePlugin


// WEBPACK FOOTER //
// ./src/plugins/windowState/index.js